<div style="width: 100wh;height: 100vh;">
    <div class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>
</div>